
const key_session = 'user_state';
const key_last_page = 'sess_last_page';

const _storage = {
    set(_key, _obj) {
        return localStorage.setItem(_key, JSON.stringify(_obj));
    },
    get(_key) {
        let data = localStorage.getItem(_key);
        return data && data.length ? JSON.parse(data) : undefined;
    }
};

const s_storage = {
    set(_key, _obj) {
        return sessionStorage.setItem(_key, JSON.stringify(_obj));
    },
    get(_key) {
        let data = sessionStorage.getItem(_key);
        return data && data.length ? JSON.parse(data) : undefined;
    }
};
export const session_Storage = {
    setLastPage(_obj) {
        let formatted = {
            path: _obj.path || '',
            fullPath: _obj.fullPath || '',
            query: _obj.query || {},
            meta: _obj.meta || {},
            params: _obj.params || {}
        };
        return s_storage.set(key_last_page, formatted);
    },
    getLastPage() {
        return s_storage.get(key_last_page);
    },
    setSession(_object) {
        return s_storage.set(key_session, _object);
    },
    getSession() {
        return s_storage.get(key_session) || {};
    }

};
export const Local_Storage = {
    setLastPage(_obj) {
        let formatted = {
            path: _obj.path || '',
            fullPath: _obj.fullPath || '',
            query: _obj.query || {},
            meta: _obj.meta || {},
            params: _obj.params || {}
        };
        return _storage.set(key_last_page, formatted);
    },
    getLastPage() {
        return _storage.get(key_last_page);
    },
    setSession(_object) {
        return _storage.set(key_session, _object);
    },
    getSession() {
        return _storage.get(key_session) || {};
    }

};

// 保存页面的请求参数，返回上一页的参数等，用于避免页面刷新导致的参数丢失等问题
export const Page_Param_Storage = {
    getParamKey() {
        return  'st-page-param-1';
    },
    getBackKey() {
        return  'st-page-back-1';
    },
    setParam(param) {
        _storage.set(this.getParamKey(), param);
    },
    mergeParam(param) {
        let old = this.getParam();
        for (let idx in param) {
            if (param.hasOwnProperty(idx)) {
                old[idx] = param[idx];
            }
        }
        _storage.set(this.getParamKey(), old);
    },
    getParam() {
        return _storage.get(this.getParamKey());
    },
    setBackUrl(back) {
        _storage.set(this.getBackKey(), back);
    },
    getBackUrl() {
        return _storage.get(this.getBackKey());
    }
};
